import { type RootState } from "features/Application/store/store";

export const getSearchResults = (state: RootState) => state.content.searchResults;
export const selectSearch = (state: RootState) => state.content.searchResults.search;
export const selectSearchFilters = (state: RootState) => state.content.searchResults.search.appliedFilters;
export const selectSearchTerm = (state: RootState) => state.content.searchResults.search.term;
export const selectSearchResults = (state: RootState) => state.content.searchResults.items;
export const selectSearchSortType = (state: RootState) => state.content.searchResults.search.sortType;
export const selectSearchResultsStatus = (state: RootState) => state.content.searchResults.status;
export const selectSearchResultsError = (state: RootState) => state.content.searchResults.errorMessage;
export const selectSearchResultsActivePage = (state: RootState) => state.content.searchResults.activePage;
export const selectSearchResultsReachedEnd = (state: RootState) => state.content.searchResults.reachedEnd;
export const selectFilterOptions = (state: RootState) => state.content.searchResults.filterOptions;
